/**
 * @generated SignedSource<<fc4609eacff7aac3a01358ca4c0c11ad>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentMethodSelectedCustomerRegisterForm_charge$data = {
  readonly id: string;
  readonly paymentMethodSelected: string | null | undefined;
  readonly " $fragmentType": "PaymentMethodSelectedCustomerRegisterForm_charge";
};
export type PaymentMethodSelectedCustomerRegisterForm_charge$key = {
  readonly " $data"?: PaymentMethodSelectedCustomerRegisterForm_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentMethodSelectedCustomerRegisterForm_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentMethodSelectedCustomerRegisterForm_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "paymentMethodSelected",
      "storageKey": null
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "ed3ed6b57511dfffdb4772d616823c1b";

export default node;
